import { FC } from "react";
import { EnvironmentsList } from "./EnvironmentsList";
import { useEnvironments, useInternalEnvironments } from "./Environments.hook";
import "./style.css";

export const Environments: FC = () => {
  const { state, headers } = useEnvironments();

  const { state: internalState, headers: internalHeaders } =
    useInternalEnvironments();

  const { envs } = state;
  const { envs: internalEnvs } = internalState;

  return (
    <>
      <h2 className="table-header">Internal</h2>
      <table className="environment-list">
        <EnvironmentsList envs={internalEnvs} headers={internalHeaders} />
      </table>

      <h2 className="table-header">Countries</h2>
      <table className="environment-list">
        <EnvironmentsList envs={envs} headers={headers} />
      </table>
    </>
  );
};
